import { render, staticRenderFns } from "./EquipamentoLimpezaAutomatizada.vue?vue&type=template&id=f5416b2e&"
import script from "./EquipamentoLimpezaAutomatizada.vue?vue&type=script&lang=js&"
export * from "./EquipamentoLimpezaAutomatizada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports